import { defaultInstance } from 'src/api/instance';
import { configVars } from 'src/helpers';

export interface DisputeCategory {
  id: string;
  name: string;
  description: string | null;
  active: boolean;
  display_order?: number;
}

export interface SendDisputeRequest {
  entry_id: string;
  dispute_category_id: string;
  description: string;
}

export interface SendDisputeResponse {
  success: boolean;
  message: string;
  dispute_id: string;
}

const api = {
  getCategories: async (): Promise<DisputeCategory[]> => {
    const response = await defaultInstance.get(`${configVars.api_url}/disputes/categories`);
    return response.data || [];
  },

  sendDispute: async (request: SendDisputeRequest): Promise<SendDisputeResponse> => {
    const response = await defaultInstance.post(
      `${configVars.api_url}/disputes/send_dispute`,
      request
    );
    return response.data;
  }
};

export default api;
